// The japoniacars.pl pages, each on the path it has on the live site.

import HomePage from './HomePage.vue'
import ONasPage from './ONasPage.vue'
import ImportPage from './ImportPage.vue'
import KalkulatorPage from './KalkulatorPage.vue'
import AukcjePage from './AukcjePage.vue'
import SamochodyPage from './SamochodyPage.vue'
import CarPage from './CarPage.vue'
import WynikiWyszukiwaniaPage from './WynikiWyszukiwaniaPage.vue'
import KontaktPage from './KontaktPage.vue'
import PolitykaPrywatnosciPage from './PolitykaPrywatnosciPage.vue'

export const sitePages = [
  { path: '/', name: 'site-home', component: HomePage },
  { path: '/o-nas/', name: 'site-o-nas', component: ONasPage },
  { path: '/import/', name: 'site-import', component: ImportPage },
  { path: '/kalkulator/', name: 'site-kalkulator', component: KalkulatorPage },
  { path: '/aukcje/', name: 'site-aukcje', component: AukcjePage },
  { path: '/samochody/', name: 'site-samochody', component: SamochodyPage },
  // One view for all six cars; the data lives in src/data/cars.js.
  { path: '/samochody/:slug/', name: 'site-samochod', component: CarPage },
  { path: '/wyniki-wyszukiwania/', name: 'site-wyniki-wyszukiwania', component: WynikiWyszukiwaniaPage },
  { path: '/kontakt/', name: 'site-kontakt', component: KontaktPage },
  { path: '/polityka-prywatnosci/', name: 'site-polityka-prywatnosci', component: PolitykaPrywatnosciPage },
]

export default sitePages
